import Ciudades from '../assets/data/ciudades.json'

/**
 * Resuelve el código DANE de ciudad destino (5 dígitos) para liquidación Envía.
 * Prioridad: ciudad del formulario → ciudad del pedido.
 */
export function resolveShippingDestinationCityCode(
  orderDetail: { shippingAddress?: { city?: string } } | null | undefined,
  formData: { destinoCiudad?: string } | null | undefined
): string {
  const fromForm = resolveCityCodeFromLabel(formData?.destinoCiudad)
  if (fromForm) return fromForm

  const fromOrder = orderDetail?.shippingAddress?.city
  if (fromOrder) {
    const code = resolveCityCodeFromLabel(String(fromOrder))
    if (code) return code
  }

  return ''
}

export function resolveCityCodeFromLabel(ciudadLabel?: string): string {
  if (!ciudadLabel || typeof ciudadLabel !== 'string') return ''
  const trimmed = ciudadLabel.trim()
  if (!trimmed) return ''

  if (/^\d{5}$/.test(trimmed)) return trimmed

  const match = Ciudades.find(
    (c) => c.ciudad === trimmed || c.codigo === trimmed
  )
  return match?.codigo ?? ''
}
